import { NBN_PERSISTENT_STORE_KEYS } from '@belong/constants';
import { logger } from '@belong/logging';
import { INbnPersistedData } from './types/persistedData';

export const getPersistedOrder = (): INbnPersistedData => {
  try {
    const storedData = window.localStorage.getItem(NBN_PERSISTENT_STORE_KEYS.NBN_PERSISTED_ORDER);
    return storedData ? (JSON.parse(storedData) as INbnPersistedData) : ({} as INbnPersistedData);
  } catch (error) {
    logger.error('Failed to read persisted NBN order from localStorage', error);
    return {} as INbnPersistedData;
  }
};

export const setPersistedOrder = (order: INbnPersistedData): void => {
  try {
    window.localStorage.setItem(NBN_PERSISTENT_STORE_KEYS.NBN_PERSISTED_ORDER, JSON.stringify(order));
  } catch (error) {
    logger.error('Failed to write persisted NBN order to localStorage', error);
  }
};
